'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _webUtils = require('@vezeeta/web-utils');

var _SignOut = require('./SignOut');

var _SignOut2 = _interopRequireDefault(_SignOut);

var _SignIn = require('./SignIn');

var _SignIn2 = _interopRequireDefault(_SignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var authenticate = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var successCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var responseStatusCode = arguments[1];
    var statusCode, jwtToken, validateToken, validateTokenHeader, validateTokenResponse, reGenerateToken, reGenerateTokenBody;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            statusCode = responseStatusCode;
            jwtToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);

            if (statusCode) {
              _context.next = 9;
              break;
            }

            validateToken = new _webUtils.API();
            validateTokenHeader = [{
              key: 'x-vzt-authentication',
              value: jwtToken
            }];
            _context.next = 7;
            return validateToken.get(_webUtils.Urls.validateToken, validateTokenHeader);

          case 7:
            validateTokenResponse = _context.sent;

            statusCode = validateTokenResponse.status;

          case 9:

            if (_webUtils.STATUS.isNotAuthorized(statusCode)) {
              reGenerateToken = new _webUtils.API();
              reGenerateTokenBody = {
                AccountKey: (0, _webUtils.decodeJwtToken)(jwtToken).payLoad.unique_name,
                Token: jwtToken
              };


              reGenerateToken.post(_webUtils.Urls.reGenerateToken, reGenerateTokenBody).then(function (responseReGenerate) {
                if (_webUtils.STATUS.isSuccess(responseReGenerate.status)) {
                  (0, _SignIn2.default)(responseReGenerate.data);
                  sessionStorage.setItem('session', 'true');
                  successCallback();
                } else {
                  (0, _SignOut2.default)();
                }
              });
            } else if (_webUtils.STATUS.isForbidden(statusCode)) {
              (0, _SignOut2.default)();
            } else if (_webUtils.STATUS.isSuccess(statusCode)) {
              sessionStorage.setItem('session', 'true');
              successCallback();
            }

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function authenticate() {
    return _ref.apply(this, arguments);
  };
}();

exports.default = authenticate;
module.exports = exports['default'];